'use client';
import { useEffect, useState } from 'react';

import { UiLandingNavigationBioderma } from '@/fo/ui/landing/navigation/bioderma';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { BuyNow } from '../components/BuyNow/BuyNow';
import { Help } from '../components/Help/Help';
import { HeroBanner } from '../components/HeroBanner/HeroBanner';
import { Quote } from '../components/Quote/Quote';
import { Results } from '../components/Results/Results';
import { Statistic } from '../components/Statistic/Statistic';
import { Wards } from '../components/Wards/Wards';

import { styles } from './FeatureLandingPageBiodermaGalchonok.styles';

export interface Navigation {
  label: React.ReactNode;
  anchor: string;
}

export interface FeatureLandingPageBiodermaGalchonokProps {
  navigation: Navigation[];
}

export function FeatureLandingPageBiodermaGalchonok({
  navigation
}: FeatureLandingPageBiodermaGalchonokProps) {
  const slots = styles();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const footer = document.querySelector('footer');

        setIsScrolled(scrollY > 100);
        setIsNearFooter(
          footer
            ? footer.getBoundingClientRect().top < windowHeight
            : scrollY + windowHeight >
                document.documentElement.scrollHeight - 200
        );
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className={slots.base()}>
      <div className="relative">
        <HeroBanner />
        <UiLandingNavigationBioderma
          className={slots.navigation({ isScrolled, isNearFooter })}
          items={navigation}
        />
      </div>

      <div className={slots.resultsAndQuote()}>
        <picture>
          <source
            srcSet={staticMediaUrl('landing/bioderma_galchonok/cap-mob.png')}
            media="(max-width: 1023px)"
          />
          <img
            className={slots.cap()}
            src={staticMediaUrl('landing/bioderma_galchonok/cap.png')}
            alt="Cap"
          />
        </picture>
        <Results className={slots.results()} />
        <Quote className={slots.quote()} />
      </div>

      <div className={slots.bottom()}>
        <picture>
          <source
            srcSet={staticMediaUrl(
              'landing/bioderma_galchonok/bg-blue-mob.png'
            )}
            media="(max-width: 767px)"
          />
          <img
            className={slots.bg()}
            src={staticMediaUrl('landing/bioderma_galchonok/bg-blue.png')}
            alt="Cap"
          />
        </picture>
        <Statistic className={slots.statistic()} />
        <Help className={slots.help()} />
        <Wards className={slots.wards()} />
        <div className={slots.disclaimer()}>
          <p className={slots.disclaimerText()}>
            1 - Церебральный паралич. Фонд направляет средства на содействие в
            организации реабилитации детей и молодежи с органическим поражением
            нервной системы, а также иными тяжелыми заболеваниями.
          </p>
          <p className={slots.disclaimerText()}>
            2 — Продукты участвующие в акции: Мицеллярная вода SENSIBIO H2O,
            500&nbsp;мл; SENSIBIO Легкий крем Defensive, 40&nbsp;мл; SENSIBIO
            сыворотка Defensive. Срок проведения акции: с 1&nbsp;июля по
            31&nbsp;августа 2026.
          </p>
        </div>
      </div>

      <BuyNow isNearFooter={isNearFooter} />
    </div>
  );
}
